import { Image, Popconfirm, Space, Tag, Tooltip } from "antd";
import { Button } from "src/components/actions/button";
import { PencilSvg, TrashSvg } from "src/components/Svg";
import styled from "styled-components";

export function getColumns(onEdit, onDelete) {
  return [
    {
      // sorter: true — сортировка серверная. Компаратор здесь переставлял бы только текущую
      // страницу и показывал бы порядок, которого на самом деле нет.
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: true,
    },
    {
      title: "Картинка",
      dataIndex: "imageUrl",
      key: "imageUrl",
      // Источник подписан: иначе непонятно, почему у одной категории картинку можно убрать, а у другой нет.
      render: (url, record) =>
        url ? (
          <ImageCell>
            <Image src={url} width={48} height={48} style={{ objectFit: "contain" }} />
            <StyledTag color={record.hasOwnImage ? "purple" : "default"}>
              {record.hasOwnImage ? "своя" : "из CRM"}
            </StyledTag>
          </ImageCell>
        ) : (
          "—"
        ),
    },
    {
      title: "Название",
      dataIndex: "nameRu",
      key: "nameRU",
      // Раньше здесь стоял компаратор по id — колонка «Название» сортировалась по идентификатору.
      sorter: true,
    },
    {
      title: "Группы категорий",
      dataIndex: "groups",
      key: "groups",
      render: (data) =>
        data.map((item, i) => (
          <StyledTag
            key={`groups_${i}`}
            color={item.disabled ? "default" : "purple"}
            style={{ opacity: item.disabled ? "50%" : "100%" }}
          >
            {item.label}
          </StyledTag>
        )),
    },
    {
      title: "Позиция",
      dataIndex: "sortWeight",
      key: "sortWeight",
      sorter: true,
      // Порядок выкладки — то, как список отдаётся по умолчанию, стрелка это и показывает.
      defaultSortOrder: "ascend",
    },
    {
      title: "Включен",
      dataIndex: "isActive",
      key: "isActive",
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      title: "Показывать на главной",
      dataIndex: "isShowToMain",
      key: "isShowToMain",
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    ...(onEdit || onDelete ? [{
      title: "Действие",
      key: "action",
      render: (_, record) => (
        <Space size="small">
          {onEdit && (
            <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <PencilSvg />
              </Button>
            </Tooltip>
          )}
          {/*<Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
            <Popconfirm
              placement="left"
              title="Действительно хотите удалить?"
              onConfirm={() => onDelete(record.id)}
              onCancel={() => stopPropagation}
            >
              <Button size="small" type="link" onClick={stopPropagation}>
                <TrashSvg />
              </Button>
            </Popconfirm>
          </Tooltip>*/}
        </Space>
      ),
    }] : []),
  ];
}

const stopPropagation = (e) => {
  e?.stopPropagation();
};

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`;

const ImageCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
